import { AnimatePresence } from 'framer-motion';
import React, { FunctionComponent, useEffect } from 'react';

import GridView from 'components/GridView/GridView';
import { WorkProjectsTypes } from 'containers/WorkPage/WorkPage.types';
import { useGlobalStore } from 'store';

import * as S from './GridTiles.styles';

export interface GridTilesProps {
  projects: WorkProjectsTypes[];
}

const defaultProps: Partial<GridTilesProps> = {
  projects: [],
};

const GridTiles: FunctionComponent<GridTilesProps> = ({
  projects,
  ...rest
}) => {
  const { isGridView, activeFilter, headerText, setHeaderText } =
    useGlobalStore();

  useEffect(() => {
    setHeaderText({
      ...headerText,
      normal: '',
      colored: '',
      color: '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGridView]);

  const filteredProjects = projects.filter(
    ({ tag, tags }) =>
      tag?.tag === activeFilter ||
      tags?.some(t => t?.tag === activeFilter) ||
      !activeFilter
  );

  return (
    <S.Wrapper {...rest}>
      <AnimatePresence mode="wait">
        <GridView projects={filteredProjects} />
      </AnimatePresence>
    </S.Wrapper>
  );
};

GridTiles.defaultProps = defaultProps;

export default GridTiles;
